import { Fragment , useContext } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { UserContext } from '../../components/contexts/user.context';
import { ReactComponent as CrwnLogo } from '../../assets/crown.svg';

import './navigation.styles.scss';

const Navigation = () => {

  const {currentUser} = useContext(UserContext); // as a hook
  console.log("current user = ", currentUser);
  // alert("HI" ,currentUser);
  return (
    <Fragment>
      <div className='navigation'>
        <Link className='logo-container' to='/'>
          <CrwnLogo className='logo' />
        </Link>
        <div className='nav-links-container'>
          <Link className='nav-link' to='/shop'>
            SHOP
          </Link>
          <Link className='nav-link' to='/auth'>
            SIGN IN
          </Link>
        </div>
      </div>
      <Outlet />
    </Fragment>
  );
};

export default Navigation;
